import React from "react";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteMedia } from "actions/agents";
import { dateTimeFormatter } from "utils/utils";
import { useAuthContext } from "contexts/AuthContext";

export const MediaItem = ({ item, index, toast, onRowClick = () => { } }) => {
  const { activeUser } = useAuthContext();
  const dispatch = useDispatch();
  return (
    <div
      className="media-item relative flex flex-col min-w-0 break-words w-full mb-8 shadow-lg rounded-lg bg-white text-blueGray-700"
      style={{ padding: "20px" }}
      onClick={() => onRowClick(item)}
    >
      <div style={{ fontWeight: "bold" }}>
        {index + 1}. {item.name}{" "}
        {item.token_count
          ? `(${Intl.NumberFormat().format(item.token_count)} tokens)`
          : ""}
      </div>
      <div>
        Uploaded on {dateTimeFormatter.format(new Date(item.created_at))}
      </div>
      <div>{item.public_id}</div>
      <div>{item.path}</div>
      <div>{item.summary}</div>
      <div style={{ fontWeight: "bold" }}>
        {item.tags ? `Tags: ${item.tags.map((e) => e.name).join(", ")}` : ""}
      </div>
      {activeUser && activeUser.user_type === "admin" && (
        <div
          className="bg-red-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          style={{ width: "78px", marginTop: "15px", alignSelf: "flex-end" }}
          onClick={(e) => {
            e.stopPropagation();
            confirmDialog({
              message: `Are you sure you want to delete media ${item.name}?`,
              header: "Delete Media",
              icon: "pi pi-exclamation-triangle",
              accept: () => {
                dispatch(
                  deleteMedia(item.public_id, () => {
                    toast.current.show({
                      severity: "info",
                      summary: "Deleted",
                      detail: "Media Session Deleted",
                      life: 3000,
                    });
                  })
                );
              },
            });
          }}
        >
          delete
        </div>
      )}
    </div>
  );
};

export default MediaItem;
